<template>
    <div class="h-full w-full">
        <transition
            enter-active-class="transition duration-400 ease-in"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition duration-100 ease-out"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
            class="h-full"
        >
            <div v-if="isLoading" class="fixed top-0 bottom-0 left-0 right-0 bg-black/[0.7] flex flex-col justify-center items-center z-40"
                    tabindex="-1" >
                <div class="flex flex-col justify-center items-center p-4 rounded-md">
                <svg aria-hidden="true" class="mx-1 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600"
                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#d3d3d3"/>
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="#2E9CCA"/>
                </svg>
                <div class="text-white p-4 whitespace-nowrap text-sm">
                    Please Wait.
                </div>
                </div>
            </div>
        </transition>
        <div v-if="containerType==='modal'" class="h-full w-full">
            <!-- <HeadlessDialogBox v-if="openDialogBox" @close-dialog-box="closeDialogBox">
                <template #header>
                    <span>{{ responseStatus }}</span>
                </template>
                <template #body>
                    <span>{{ responseMessage }}</span>
                </template>
            </HeadlessDialogBox> -->
            <div class="flex flex-row w-full items-center py-1 pl-2 border-b border-gray-400">
                <div>
                    Choose Job Type:
                </div>
                <base-list-box
                    class="rounded-b-md h-8 w-[300px]"
                    placeholder="Select Job Type"
                    :options="jobTypeOptions"
                    :modelValue="jobType"
                    :multiple="false"
                    @update:modelValue="setJobType"
                />
            </div>
            <div v-if="jobType==='full_text_search'" class="h-full w-full">
                <FullTextSearchForm
                    :formCleared="formCleared"
                    @submit-fts="closeModalOpenDialogBox"
                    @set-form-cleared-false="setFormClearedFalse"
                    @set-is-loading-true="setIsLoadingTrue"
                    @set-is-loading-false="setIsLoadingFalse"
                    
                />
            </div>
        </div>
        <div v-if="containerType==='rightSideBar'" class="text-xs w-full h-full">
            <div v-if="openDialogBox"
                class="break-normal text-left align-middle py-6 border-b border-gray-400 w-full"
            >
                <div class=" break-normal text-sm leading-4 text-gray-900">{{ responseStatus }}</div>
                <div class="mt-2 break-normal text-xs text-gray-500">{{ responseMessage }}</div>
                <div class="mt-4 flex justiyf-center">
                    <base-button-affirmative type="button" @click="clearSideBar">Okay</base-button-affirmative>
                </div>
            </div>
            <div v-else class="h-full w-full ">
                <div v-if="jobType==='full_text_search'" class="h-full w-full ">
                    <FullTextSearchForm
                        :formCleared="formCleared"
                        @submit-fts="submitFullTextSearch"
                        @set-form-cleared-false="setFormClearedFalse"
                    />
                </div>
            </div>

        </div>
    </div>
</template>

<script setup>
import {ref, reactive, defineProps, defineEmits, watch, onMounted } from 'vue';
import HeadlessDialogBox from '@/components/HeadlessDialogBox.vue';
import FullTextSearchForm from '../full-text-search/FullTextSearchForm.vue';

const openDialogBox = ref(false);

const isLoading = ref(false);

const responseStatus = ref('');
const responseMessage = ref('');

const props = defineProps(['containerType', 'jobType'])

const emit = defineEmits(['close', 'refetch-jobs'])

const jobType = ref('')

const formCleared = ref(false)

const query = reactive({
    id: null,
    jobTitle: '',
    parameters: []

})
const jobTitle = ref('')
const jobDetails = ref('')

onMounted(() => {
  jobType.value = props.jobType ? props.jobType : ''
});

watch(() => query.id, () => {
        if(query.id) {
            jobTitle.value = query.jobTitle
            if(query.parameters.length > 0) {
                searchPhraseRows.value = []
                query.parameters.forEach((parameter) => {
                    if(parameter.parameter.parameter_name === 'search_phrase') {
                        searchPhraseRows.value.push({
                            key: Math.random(),
                            id: 1,
                            parameter_value_string: parameter.parameter_value_string
                        })
                    } else if (parameter.parameter.parameter_name === 'collection_tag_name') {
                        collectionTagName.value = parameter.parameter_value_string
                    }
                })
            }
        } else {
            jobTitle.value = ''
            collectionTagName.value = null
            searchPhraseRows.value = [{
                key: Math.random(),
                id: 1,
                parameter_value_string: null    
            }]
        }
    })

const jobTypeOptions = ref([
    { value: "clear", label: "------------" },
    { value: 'full_text_search', label: "Full Text Search" },
])

function clearFields() {
    setQuery('clear')
    jobTitle.value = ''
    jobDetails.value = ''
    collectionTagName.value = null
    searchPhraseRows.value = [{
        key: Math.random(),
        id: 1,
        parameter_value_string: null    
    }]
    formCleared.value = true
}

function setFormClearedFalse(){
    formCleared.value = false
}

function setIsLoadingTrue() {
    isLoading.value = true
}

function setIsLoadingFalse() {
    isLoading.value = false
}

function setJobType(target) {
    if (target === "clear") {
    jobType.value = '';
  } else {
    jobType.value = target;
  }
}

function setQuery(target) {
if (target === "clear") {
    query.id = null,
    query.jobTitle = ''
    query.parameters = []
  } else {
    query.id = target.id;
    query.jobTitle = target.job_title;
    query.parameters = target.parameters;
  }
}

const collectionTagName = ref(null)

const searchPhraseRows = ref([{
    key: Math.random(),
    id: 1,
    parameter_value_string: null    
}])

function closeModalOpenDialogBox(response) {
    console.log('closeModalOpenDialogBox')
    console.log(response)
    emit('refetch-jobs')
    emit('close', response)
}

function clearSideBar() {
    emit('refetch-jobs')
    openDialogBox.value = false
    jobType.value = 'full_text_search'
    clearFields()
}


function submitFullTextSearch(response) {
    console.log('Submit Full Text Search')
    openDialogBox.value = true
    console.log('open dialog box', openDialogBox.value)
    responseStatus.value = response.responseStatus
    responseMessage.value = response.responseMessage
}

</script>